<template>
<footer v-if="DATA_IS_LOADED" :style="{ 'background-color': this.transparent, 'opacity': this.opacity }">
    <div class="footer__content">

        <address class="footer__address">
            <a :href="'tel:' + contacts.phone"
               class="footer__contact-link">{{contacts.phone}}</a>
            <a :href="'mailto:' + contacts.mail"
               class="footer__contact-link">{{contacts.mail}}</a>
            <div class="footer__address-line">
                <strong>{{ contacts.name }}</strong>
                {{ contacts.street }},
                {{ contacts.zip }}
            </div>
        </address>
        <ul class="social-links">
            <li v-for="item in socialLinks"
                :key="item.shortName">
                <a :href="item.link"
                   :class="'social-link social-link--' + item.name">{{item.shortName}}</a>
            </li>
        </ul>
    </div>
</footer>
</template>

<script>
// import Marquee3k from 'marquee3000' // Currently removed b/c it's buggy
// Made my own on https://codepen.io/erikthalen/pen/bxVgrw
import {
    mapState
} from 'vuex'
export default {
    name: 'Footer',
    props: {
        noBgColor: Boolean
    },
    data() {
        return {
            transparent: this.noBgColor ? 'transparent' : '',
        }
    },
    computed: mapState({
        DATA_IS_LOADED: state => state.data.isLoaded,
        opacity: state => state.isSwitchingPage ? '0' : '1',

		contacts: state => state.data.contactsPage,
		bannerText: state => state.data.footerBanner,
		socialLinks: state => state.data.socialLinks,
    }),
}
</script>

<style scoped lang="scss">
@import "../scss/globals.scss";

footer {
    // position: fixed;
    // bottom: 0;
    // left: 0;
    z-index: 0;

    width: 100%;
    line-height: 2;

    box-sizing: border-box;

    color: $color-white;
    background-color: $color-dark-grey;

    .footer {
        &__content {
            padding: $margin1-2 $margin1-8;

            box-sizing: border-box;
            text-align: center;

            @media screen and (min-width: 440px) {
                padding: $margin1-1 $margin1-4;
            }
            @media screen and (min-width: 769px) {
                padding: rem($space1-1);
            }
        }
        &__address {
            font-style: normal;
            margin-bottom: rem(15);
            &-line {
                font-size: rem(12);
                @media screen and (min-width: 500px) {
                    font-size: rem(16);
                }
            }
        }
        &__contact-link {
            font-family: $font-expanded;
            line-height: 1.1;
            font-size: rem(18);
            display: block;
            &:last-of-type {
                margin-bottom: rem(15);
            }
            @media screen and (min-width: 500px) {
                font-size: rem(25);
            }
            @media screen and (min-width: 700px) {
                font-size: rem(43);
            }
        }

    }

    .links {
        padding: $margin1-2 0;

        h2 {
            font-size: $font-size-xs;
            @media screen and (min-width: 440px) {
                font-size: $font-size-s;
            }
        }
    }

    p {
        font-size: $font-size-xxs;
        @media screen and (min-width: 440px) {
            font-size: $font-size-xs;
        }
    }

    .title {
        font-family: $font-expanded;
        font-size: $font-size-s;
    }

    .social-links {
        display: flex;
        list-style: none;
        flex-wrap: nowrap;
        justify-content: center;
		margin-top: 0.3em;
        padding: 0;

        > li {
            display: inline-block;
            padding: 0 rem(10);
        }
        .social-link {
            transition: transform 0.2s;
			transform: scale(1.00001);
            font-family: $font-expanded;
            font-size: rem(12);
            line-height: rem(48);
            border-radius: 50%;
            border: rem(1) solid $color-white;
            width: rem(51);
            height: rem(51);
            text-align: center;
            display: block;
            &:hover {
                transform: scale(1.1);
            }

        }
    }
}
</style>
